module.exports = __webpack_public_path__ + "img/arrow_right.6f461b54.svg";